import { useTranslation } from 'react-i18next';
import { Button } from '../../../ui/index.js';
import type { TransitionAction } from '../role.js';

export function RequestDrawerStickyActionBar({
  actions,
  onAction,
}: {
  actions: TransitionAction[];
  onAction: (a: TransitionAction) => void;
}) {
  const { t } = useTranslation('requests');
  return (
    <div
      data-testid="request-drawer-sticky-bar"
      style={{
        flex: 'none',
        padding: '12px 16px calc(12px + env(safe-area-inset-bottom))',
        background: 'var(--bg-1)',
        borderTop: '1px solid var(--border-1)',
        display: 'flex',
        gap: 8,
        flexWrap: 'wrap',
      }}
    >
      {actions.map((a) => {
        const tooltip = a.disabledReasonKey ? (t(a.disabledReasonKey) as string) : undefined;
        const button = (
          <Button
            kind={a.kind}
            icon={a.icon}
            disabled={a.disabled === true}
            onClick={() => onAction(a)}
          >
            {t(a.labelKey)}
          </Button>
        );
        // #1164: native `disabled` suppresses hover events, so the
        //   tooltip lives on a wrapping span (matches the russia-rate
        //   pattern from #707). The button keeps its localized text as
        //   its accessible name; the tooltip is supplementary, not the
        //   primary label.
        return tooltip ? (
          <span key={a.key} title={tooltip} data-testid={`request-drawer-action-tooltip-${a.key}`}>
            {button}
          </span>
        ) : (
          <span key={a.key}>{button}</span>
        );
      })}
    </div>
  );
}
